import React from "react";
import "./style.css";

const CustomImageComponent = ({ user, size, style }) => {
  return (
    <div>
      {user.photoURL ? (
        <img
          src={user.photoURL}
          alt={user.displayName ? user.displayName.charAt(0) : "me"}
          className={`custom-image -${size}`}
          style={style}
        />
      ) : (
        <div className={`custom-image-text -${size}`} style={style}>
          {user.displayName ? user.displayName.charAt(0) : "me"}
        </div>
      )}
    </div>
  );
};

export default CustomImageComponent;
